import { useState } from 'react'
import type { AdminEngineItem } from '../types/review.types'

export function useReviewNavigation(pendingItems: AdminEngineItem[]) {
  const [reviewIndex, setReviewIndex] = useState(0)
  const [reviewEngineId, setReviewEngineId] = useState<string | null>(null)
  const [reviewDialogOpen, setReviewDialogOpen] = useState(false)

  const onReview = (id: string) => {
    const idx = pendingItems.findIndex((item) => item.id === id)
    setReviewIndex(idx >= 0 ? idx : 0)
    setReviewEngineId(id)
    setReviewDialogOpen(true)
  }

  const canGoPrev = reviewIndex > 0
  const canGoNext = reviewIndex < pendingItems.length - 1

  const goPrev = canGoPrev
    ? () => {
        const prevIdx = reviewIndex - 1
        setReviewIndex(prevIdx)
        setReviewEngineId(pendingItems[prevIdx].id)
      }
    : undefined

  const goNext = canGoNext
    ? () => {
        const nextIdx = reviewIndex + 1
        setReviewIndex(nextIdx)
        setReviewEngineId(pendingItems[nextIdx].id)
      }
    : undefined

  return {
    reviewIndex,
    reviewEngineId,
    reviewDialogOpen,
    setReviewDialogOpen,
    setReviewEngineId,
    onReview,
    goNext,
    goPrev,
  }
}
